import { render, staticRenderFns } from "./PurchaseReturnBill.vue?vue&type=template&id=5646ee36&scoped=true&"
import script from "./PurchaseReturnBill.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnBill.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseReturnBill.vue?vue&type=style&index=0&id=5646ee36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5646ee36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VRow})
